import { useCallback, RefObject } from 'react';
import { useMessage } from './useMessage';
import { useMouthAnimation } from './useMouthAnimation';
import { useAudioStore } from '../stores/useAudioStore';
import { Live2DModel } from 'pixi-live2d-display/cubism4';

/**
 * メッセージ表示システムを統合管理するフック
 * 空ちゃんのセリフ（口パク付き）とシステムメッセージ（SE付き）を管理
 */
export function useMessageSystem(live2dModelRef: RefObject<Live2DModel | null>) {
  const {
    currentMessage,
    messageVisible,
    showMessage: baseShowMessage,
    hideMessage,
  } = useMessage();
  
  const { animateMouthForDuration } = useMouthAnimation();

  // 空ちゃんのセリフ表示（口パクアニメーション付き）
  const showMessageWithMouth = useCallback((text: string, duration?: number) => {
    baseShowMessage(text, { duration });
    if (live2dModelRef.current) {
      animateMouthForDuration(live2dModelRef.current, text);
    }
  }, [baseShowMessage, animateMouthForDuration, live2dModelRef]);
  
  // システムメッセージ表示（口パクなし、SE付き）
  const showSystemMessage = useCallback((text: string, duration?: number) => {
    baseShowMessage(text, { duration });
    
    // システムSEを再生
    const audio = new Audio('/assets/audio/se/up.mp3');
    const { audioSettings } = useAudioStore.getState();
    audio.volume = audioSettings.seVolume * audioSettings.masterVolume;
    audio.play().catch(() => {
      // 自動再生ポリシーでブロックされた場合は無視
    });
  }, [baseShowMessage]);

  return {
    currentMessage,
    messageVisible,
    showMessageWithMouth,
    showSystemMessage,
    hideMessage,
  };
}